var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { apiClient } from '../interceptor/interceptor';
/**
 * Manage (defer/dismiss) patient alert.
 *
 * Backend contract:
 * - POST /screener/alerts
 * - Body includes patientId, reason, optional otherReason, dismiss
 * - Returns 201 on success
 */
export const manageAlert = (body) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield apiClient.post('/screener/alerts', body);
    return response.data;
});
